var t=(t,e)=>{let l,u;let r=(a=u)=>{t(...a),u=null,l=setTimeout(()=>{l=null,u&&r()},e)};return(...t)=>l?u=t:r(t)};export{t as default};